import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-726f056a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "the-calculator__container" }
const _hoisted_2 = {
  class: "the-calculator__display",
  "data-test": "display"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalculatorButton = _resolveComponent("CalculatorButton")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.calculator.print()), 1),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (_, number) => {
      return _createVNode(_component_CalculatorButton, {
        key: number,
        onMousedown: _withModifiers(($event: any) => (_ctx.calculator.addNumber(number)), ["left"]),
        variant: "number",
        class: _normalizeClass(`the-calculator__button-${number}`),
        "data-test": `number-${number}`
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(number), 1)
        ]),
        _: 2
      }, 1032, ["onMousedown", "class", "data-test"])
    }), 64)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Operation, (symbol, operation) => {
      return (_openBlock(), _createBlock(_component_CalculatorButton, {
        key: operation,
        onMousedown: _withModifiers(($event: any) => (_ctx.calculator.setOperation(symbol)), ["left"]),
        variant: "operation",
        class: _normalizeClass(`the-calculator__button-${operation}`),
        "data-test": `operation-${operation}`
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(symbol), 1)
        ]),
        _: 2
      }, 1032, ["onMousedown", "class", "data-test"]))
    }), 128)),
    _createVNode(_component_CalculatorButton, {
      key: "decimal",
      onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.calculator.addDecimalSeparator()), ["left"])),
      variant: "operation",
      class: "the-calculator__button-decimal",
      "data-test": "decimal"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.calculator.decimalSeparator), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_CalculatorButton, {
      key: "decimal",
      onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.calculator.toggleSymbol()), ["left"])),
      variant: "operation",
      class: "the-calculator__button-symbol",
      "data-test": "symbol"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" ± ")
      ]),
      _: 1
    }),
    _createVNode(_component_CalculatorButton, {
      key: "clear",
      onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.calculator.clear()), ["left"])),
      variant: "clear",
      class: "the-calculator__button-clear",
      "data-test": "clear"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" C ")
      ]),
      _: 1
    }),
    _createVNode(_component_CalculatorButton, {
      key: "erase",
      onMousedown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.calculator.erase()), ["left"])),
      variant: "operation",
      class: "the-calculator__button-erase",
      "data-test": "erase"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FontAwesomeIcon, {
          icon: _ctx.eraseIcon,
          fixedWidth: ""
        }, null, 8, ["icon"])
      ]),
      _: 1
    }),
    _createVNode(_component_CalculatorButton, {
      key: "calculate",
      onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.calculator.calculate()), ["left"])),
      variant: "operation",
      class: "the-calculator__button-calculate",
      "data-test": "calculate"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" = ")
      ]),
      _: 1
    })
  ]))
}